import React from "react";
import { useTranslation } from "react-i18next";

const LanguageContainer: React.FC = ({ children }) => {
  const { i18n } = useTranslation();
  return (
    <div data-lang={i18n.language} data-testid="languageContainer">
      {children}
    </div>
  );
};

export default LanguageContainer;
